import React from "react";
import { Box, Typography, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

interface HeroSearchSectionProps {
  searchQuery: string;
  onChange: (value: string) => void;
}

const HeroSearchSection: React.FC<HeroSearchSectionProps> = ({ searchQuery, onChange }) => {
  return (
    <Box sx={{ textAlign: "center", mb: 6 }}>
      <Typography variant="h3" fontWeight={700} gutterBottom>
        How can we help you?
      </Typography>
      <Typography variant="body1" color="text.secondary" mb={3}>
        Search for answers or browse categories below
      </Typography>
      <Box sx={{ maxWidth: 600, mx: "auto" }}>
        <TextField
          fullWidth
          placeholder="Search for help..."
          value={searchQuery}
          onChange={(e) => onChange(e.target.value)}
          variant="outlined"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: "text.secondary" }} />
              </InputAdornment>
            ),
          }}
          sx={{
            backgroundColor: "white",
            borderRadius: 3,
            "& .MuiOutlinedInput-root": {
              borderRadius: 3,
              fontSize: "1.1rem",
              "&:hover fieldset": { borderColor: "#178B8E" },
              "&.Mui-focused fieldset": { borderColor: "#178B8E" },
              "&.Mui-focused": {
                boxShadow: "0 4px 20px rgba(23, 139, 142, 0.2)",
              },
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default HeroSearchSection;
